import * as Models from "../.";

export interface IBatch {
    id: number;
    name: string;
    fromDate: Date;
    toDate: Date;
    partner: Models.PartnerModel.IPartnerModel;
    inUse: boolean;
}

export class Batch implements IBatch {
    id: number;
    name: string;
    fromDate: Date;
    toDate: Date;
    partner: Models.PartnerModel.IPartnerModel;
    inUse: boolean;

    constructor() {
    }
}
